<template>
  <div @click="onClick">
    <div v-if="message" v-html="displayContent"></div>
  </div>
</template>
<script>
import _ from 'lodash'
const audioManager = require('../lib/AudioManager').instance
let allowNodeTypes = ['part', 'br', 'span', 'div']
export default {
  name: 'MessageWriter',
  props: {
    game: {
      type: Object,
      required: true
    },
    message: {
      type: Object,
      default: null
    }
  },
  watch: {
    'message'(content, old){
      this.resetContent()
      // console.log('current:', content, 'old:', old)
    }
  },
  data(){
    return {
      displayContent: '',
      contentHtml: '',
      parts: [],
      /** 播放的進度(字)，不是百分比 */
      progress: 0,
      timer: {
        pause: true
      },
      /** 表示播放是否完成 */
      completed: false
    }
  },
  mounted(){
    let audio = document.querySelector('#resources #type-effect')
    audio.volume = 0.3
    this.$typeAudio = {
      audio,
      playing: false,
      _volume: 0.3,
      set volume(v){
        this.audio.volume = v
        this._volume = v
      },
      get volume(){
        return this._volume
      },
      pause(){
        this.playing = false
        this.audio.pause()
      },
      play(){
        this.playing = true
        this.audio.volume = this.volume
        let promise = this.audio.play()
        this.audio.oncanplay = ()=>{
          if(this.playing){
            this.audio.play()
          }
        }
        // 自動重播
        this.audio.onEnd = ()=>{
          if(this.playing){
            this.audio.currentTime = 0
            this.audio.pause()
            this.audio.play()
          }
        }
        return promise
      }
    }
    this.resetContent()
  },
  beforeDestroy(){
    this.stopWriter()
  },
  methods: {
    resetContent(){
      /** @type {import('@/lib/Message').Message} */
      let message = this.message
      if(message){
        this.stopWriter()
        this.displayContent = ''
        this.progress = 0
        this.completed = false
        if(message.content){
          console.debug('writer-content', message.content)
          let res = message.splitContent()
          this.contentHtml = message.getContentHtml()
          // console.debug('splitContent:', res)
          this.parts = res.parts
          message._textContent = res.root.textContent
          this.startWriter()
          return
        }
      }
      this.parts = []
      this.contentHtml = ''
    },
    startWriter(){
      if(this.timer.pause){
        this.timer.pause = false
        this.$typeAudio.play()
        this.$timer = setInterval(()=>{
          if(this.progress >= this.parts.length - 1){
            this.complete()
          }else{
            this.displayContent += this.parts[this.progress]
            this.progress += 1
            this.$emit('update', {
              content: this.displayContent,
              part: this.parts[this.progress - 1],
              progress: this.progress - 1
            })
          }
        }, 70)
      }
    },
    stopWriter(){
      this.$typeAudio.pause()
      clearInterval(this.$timer)
      this.parts = []
      this.timer.pause = true
    },
    pauseWriter(){
      this.$typeAudio.pause()
      clearInterval(this.$timer)
      this.timer.pause = true
    },
    complete(){
      this.stopWriter()
      this.displayContent = this.contentHtml
      if(!this.completed){
        this.completed = true
        this.$emit('complete')
      }
    },
    onClick(e){
      this.complete()
      this.$emit('click', e)
      console.log('onClick')
    }
  }
}
</script>

<style>
  .msg-writer{
    max-height: 400px;
    min-height: 250px;

  }
</style>
